module.exports = __webpack_public_path__ + "img/example-front.5fc00f19.webp";